import { NextPage } from 'next'
import NavbarLayout from 'components/NavbarLayout'
import ScreenLayout from 'components/ScreenLayout'

import { CollectiveProvider } from 'context/CollectiveContext'
import genGetServerSideProps from 'lib/getServerSideProps/forCollectivePage'
import Forum from 'components/Collectives/DiscussionBoard/Forum'
import { ForumProvider } from 'components/Collectives/DiscussionBoard/ForumContext'

interface IProps {
  collectiveId: string
}

const DiscussionBoardPage: NextPage<IProps> = ({ collectiveId }) => {
  return (
    <CollectiveProvider collectiveId={collectiveId}>
      <NavbarLayout stuckClasses="bg-gray-100">
        <ScreenLayout layout="blank">
          <ForumProvider>
            <Forum />
          </ForumProvider>
        </ScreenLayout>
      </NavbarLayout>
    </CollectiveProvider>
  )
}

export default DiscussionBoardPage

export const getServerSideProps = genGetServerSideProps('/discussionBoard')
